
import { motion } from 'framer-motion';

export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header>
      <section id="hero" className="relative min-h-screen flex items-center overflow-hidden pt-20">
        <div className="absolute inset-0 bg-gradient-to-br from-coral/20 via-pink/30 to-purple/20"></div>
        
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/07ae0f196f500acad3011e3890262cc7.jpg"
            alt="Romantic surprise decoration with balloons, roses, and candles"
            title="Surprise decorations - romantic proposals"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 w-full">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              className="text-white"
            >
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 }}
                className="inline-block bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6"
              >
                <span className="text-sm font-medium">✨ Surprise Specialists</span>
              </motion.div>

              <motion.h1
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4 }}
                className="font-serif font-bold text-5xl md:text-6xl lg:text-7xl leading-tight mb-6"
              >
                Create Unforgettable <strong>Intimate Moments</strong>
              </motion.h1>

              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.6 }}
                className="text-lg md:text-xl text-white/90 mb-8 font-light"
              >
                From <strong>romantic proposals</strong> to milestone <strong>celebrations</strong>
              </motion.p>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.8 }}
                className="flex flex-wrap gap-4"
              >
                <button
                  onClick={() => scrollToSection('packages')}
                  className="px-8 py-4 bg-white text-charcoal font-semibold rounded-full hover:shadow-2xl transition-all text-sm md:text-base cursor-pointer whitespace-nowrap"
                >
                  Explore Packages <i className="ri-arrow-right-line ml-2"></i>
                </button>
                <button
                  onClick={() => scrollToSection('quiz')}
                  className="px-8 py-4 text-white font-medium hover:text-white/80 transition-colors text-sm md:text-base cursor-pointer whitespace-nowrap"
                >
                  Take Our Quiz →
                </button>
              </motion.div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="hidden md:flex flex-col gap-6"
            >
              <motion.div
                whileHover={{ scale: 1.05 }}
                className="bg-white/95 backdrop-blur-sm rounded-2xl p-6 shadow-xl"
              >
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-coral to-pink rounded-full flex items-center justify-center">
                    <i className="ri-heart-fill text-white text-xl"></i>
                  </div>
                  <div>
                    <div className="text-3xl font-bold text-charcoal">500+</div>
                    <div className="text-sm text-gray-600">Surprises Created</div>
                  </div>
                </div>
              </motion.div>

              <motion.div
                whileHover={{ scale: 1.05 }}
                className="bg-white/95 backdrop-blur-sm rounded-2xl p-6 shadow-xl"
              >
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-purple to-pink rounded-full flex items-center justify-center">
                    <i className="ri-star-fill text-white text-xl"></i>
                  </div>
                  <div>
                    <div className="text-3xl font-bold text-charcoal">4.9★</div>
                    <div className="text-sm text-gray-600">Average Rating</div>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          </div>
        </div>

        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <i className="ri-arrow-down-line text-white text-3xl"></i>
        </div>
      </section>
    </header>
  );
}
